import React, { useState } from 'react';
import OptionEmoji from './OptionEmoji';
import s from '../style.module.scss';

// 星级题：5 星 + 选中后右侧档位胶囊（emoji + 文案）
// 星级素材：选中黄星(big_star_light) / 未选中灰星(big_star_grey)
// 交互：悬浮预览（划过第N颗前N颗亮起+胶囊预览该档位），移出恢复已选态，点击提交选择
const starLightImg = require('@/assets/images/simulation/evaluationTool/big_star_light.webp');
const starGreyImg = require('@/assets/images/simulation/evaluationTool/big_star_grey.webp');

const StarRateRow = (props) => {
    const { question, value, onChange } = props,
        { code, title, subTitle, options = [] } = question,
        [hoverScore, setHoverScore] = useState(0),
        // 无选中时 value 为 0
        curScore = value || 0,
        // 展示分：悬浮预览优先，无悬浮时为已选分
        displayScore = hoverScore || curScore,
        curOption = options.find((ele) => ele.score === displayScore);

    return (
        <div className={s['question-row']}>
            <div className={s['question-title-wrap']}>
                <span className={s['question-title']}>{title}</span>
                {subTitle ? <span className={s['question-sub-title']}>{subTitle}</span> : null}
            </div>
            <div className={s['star-rate-wrap']}>
                <div className={s['star-list']} onMouseLeave={() => setHoverScore(0)}>
                    {options.map((option, index) => {
                        const active = displayScore >= option?.score;
                        return (
                            <img
                                key={index}
                                className={s['star-item']}
                                src={active ? starLightImg : starGreyImg}
                                alt=""
                                onMouseEnter={() => setHoverScore(option?.score)}
                                onClick={() => onChange(code, option?.score)}
                            />
                        );
                    })}
                </div>
                {curOption ? (
                    // key=score：档位变化时元素重挂载，触发淡入上浮动画，文案/表情切换更柔和
                    <div className={s['option-capsule']} key={curOption?.score}>
                        <OptionEmoji emoji={curOption?.emoji} />
                        <span>{curOption?.label}</span>
                    </div>
                ) : null}
            </div>
        </div>
    );
};

export default StarRateRow;
